
import React, { useState } from "react";
import footer from '../../components/Footer'
import "./LoginPage.css";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import AuthTemplate from "../Common/AuthTemplate";
import { useNavigate } from "react-router-dom";
import google from "./Images/Google.svg";
import facebook from "./Images/Facebook.svg";
import { endpoints } from "../services/apis";
import {
  makeUnauthenticatedPOSTRequest,
} from "../services/serverHelper";
import { useDispatch } from "react-redux";
import {
  setAccessToken,
  setRole,
  setRefreshToken,
} from "../reducer/slices/authSlice";
import Footer from "../../components/Footer";

export function AdminLoginPage() {
  const dispatch = useDispatch();

  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });

  function changeHandler(event) {
    const { name, value } = event.target;

    setFormData((prev) => {
      return {
        ...prev,
        [name]: value,
      };
    });
  }

 
const Otp_Send = async ( email) => {
    try {
     const responce = await fetch(endpoints.REGISTER_OTP_SEND,{
      method:"POST",
      headers:{
        "content-Type":"application/json",
      },
      body:JSON.stringify({
        email,
      })
    } )
    if(responce.status === 200){
      toast.success("Otp has been send... " , {
            position:"top-center"
          });
    }
    }catch (error) {
    console.log(error);
    toast.error(error);
    
  }

}
const submitHandler = async (event) => {
  event.preventDefault();
  const toastId = toast.loading("Loading...");

  try {
    const response = await makeUnauthenticatedPOSTRequest(
      endpoints.LOGIN_API,
      { ...formData, registerBy: "email" }
    );

    console.log("Login response:", response); // Debug log

    // Handle successful login
    // if (response.status === "success") {
    //   const { accessToken, refreshToken, role } = response.data;

    if (response.status === "success") {
  const { accessToken, refreshToken, role } = response.data;

  // ✅ Allow only Admin login
  if (role !== "Admin") {
    toast.update(toastId, {
      render: "Only Admins can login here",
      type: "error",
      isLoading: false,
      autoClose: 5000,
      position: "top-center",
    });
    return;
  }

  dispatch(setAccessToken(accessToken));
  dispatch(setRefreshToken(refreshToken));
  dispatch(setRole(role));
  localStorage.setItem("accessToken", accessToken);
  localStorage.setItem("refreshToken", refreshToken);
  localStorage.setItem("role", role);

  toast.update(toastId, {
    render: "Successfully logged in",
    type: "success",
    isLoading: false,
    autoClose: 5000,
    position: "top-center",
  });

  navigate("/AdminDashboard");
  return;
}

    // Handle errors from response
    if (response.status === "error") {
      const message = response.message?.toLowerCase();

      if (message?.includes("invalid") || message?.includes("credentials")) {
        toast.update(toastId, {
          render: "Wrong password. Please try again.",
          type: "error",
          isLoading: false,
          autoClose: 5000,
          position: "top-center",
        });
        return;
      }

      if (response.message === "User is not verified. Please complete the verification process.") {
        await Otp_Send(formData.email);
        toast.dismiss(toastId);
        navigate(`/verifyCode/${formData.email}`);
        return;
      }

      toast.update(toastId, {
        render: response.message || "Login failed",
        type: "error",
        isLoading: false,
        autoClose: 5000,
        position: "top-center",
      });
      return;
    }
  } catch (error) {
    console.error("Login error:", error);

    if (error.response?.status === 401) {
      toast.update(toastId, {
        render: "Invalid email or password",
        type: "error",
        isLoading: false,
        autoClose: 5000,
        position: "top-center",
      });
    } else {
      toast.update(toastId, {
        render: error.message || "Internal server error",
        type: "error",
        isLoading: false,
        autoClose: 5000,
        position: "top-center",
      });
    }
  }
};


  const googleLogin = async () => {
    navigate("https://api.ekalakaar.com/api/v1/auth/google/");
    // try {
    //   const response = await makeUnauthenticatedGETRequest(
    //     artistProfilePoints.LOGIN_WITH_GOOGLE_API
    //   );
    //   console.log("googleRes", response);
    // } catch (error) {
    //   toast.error("Something went wrong , please try again");
    //   console.log(error);
    // }
  };

  const [passwordVisible, setPasswordVisible] = useState(false);

  const togglePasswordVisibility = () => {
    setPasswordVisible(!passwordVisible);
  };

  return (
    
    <AuthTemplate justifyFlag={false}>
      <div className="loginWrapper">
        <h1 className="loginHeading">Welcome Back!</h1>
        <p className="loginPara">Login to your Account</p>
      </div>

      <form onSubmit={submitHandler} className="loginForm">
        <label htmlFor="email" className="loginFormLabel">
          <p className="loginFormPara">Email</p>
          <input
            required
            onChange={changeHandler}
            value={formData.email}
            type="email"
            name="email"
            className="loginFormInput"
            placeholder="Enter your email address"
          />
        </label>
<label htmlFor="password" className="loginFormLabel w-full">
  <p className="loginFormPara">Password</p>
  <div className="relative w-full">
    <input
      required
      onChange={changeHandler}
      value={formData.password}
      type={passwordVisible ? "text" : "password"}
      name="password"
      className="loginFormInput " // Keep original styling, just add pr-10
      placeholder="Enter your password"
    />
    <button
      type="button"
      onClick={togglePasswordVisibility}
      className="absolute right-10 top-1/2 -translate-y-1/2 text-gray-500 focus:outline-none"
    >
      {passwordVisible ? (
        // Eye Slash
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M13.875 18.825A10.05 10.05 0 0112 19c-5.523 0-10-4.477-10-10 0-1.662.407-3.226 1.125-4.613M14.121 14.121A3 3 0 119.88 9.879M21 21L3 3"
          />
        </svg>
      ) : (
        // Eye
        <svg
          xmlns="http://www.w3.org/2000/svg"
          className="h-5 w-5"
          fill="none"
          viewBox="0 0 24 24"
          stroke="currentColor"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
          />
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            strokeWidth={2}
            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-.226.75-.57 1.462-1.016 2.118M15.54 15.54A5.984 5.984 0 0112 17c-2.042 0-3.878-.98-5.04-2.54"
          />
        </svg>
      )}
    </button>
  </div>
</label>


        <div className="checkbox_forgetPassword_container">
          {/* checkbox */}
          <div className="checkboxContainer">
            <input type="checkbox" />
            <p className="login_rememberMe_Text">Remember me</p>
          </div>

          {/* forgetpassword  */}
          <p
            onClick={() => navigate("/forgetPassword")}
            className="forgotPasswordText"
          >
            Forgot Password
          </p>
        </div>

        <button type="submit" className="loginButton">
          
          Login
        </button>

 

        {/* google and facebook button */}
        {/*
        <div className="googleFacebookButton">
          <a href="https://api.ekalakaar.com/api/v1/auth/google">
            <img
              onClick={googleLogin}
              src={google}
              alt=""
              className="loginImage"
            />
          </a>

          <img src={facebook} alt="" className="loginImage" />
        </div>
          */}
        

        <p className=" navigateRegisterPara">
          Don’t have an account?
          <span onClick={() => navigate("/register")}> Register</span>
        </p>
      </form> 
    </AuthTemplate>
  
    
  );
}
